module.exports = __webpack_public_path__ + "media/images/clock-zoom-58c02eae.png";